import request from '@/utils/request'

function list () {
  return request({
    url: '/pos/store',
    method: 'get'
  })
}

export default {
  list
}
